<template>
<a class="dropdown-item" href="#">
    <slot></slot>
</a>
</template>

<script>
export default {
    
}
</script>